import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SCUIButton, SCUILoadingLinear, SCUITabs } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb, SCUICustomDataGrid } from '../../atomic/molecules';
import { TextField, Grid, Typography } from '@mui/material';
import { ShippmentQuery, StoreQuery } from '../../services/query';
import RpaQuery from '../../services/query/rpa/RpaQuery.services';
import RpaRequestList from './components/RpaRequestList';
import { RPAR } from './rpaResend.classes';
import { PageUrl } from '../../types/enums/pageUrl-enums';

export const RPAResend: FC<any> = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [shippingNumbers, setShippingNumbers] = useState('');
    const [rpaData, setRpaData] = useState<any>([]);
    const [reshippingData, setReshippingdData] = useState<any>([]);
    const [tabIndexForSelectType, setTabIndexForSelectType] = useState<any>(1);
    const [tabIndexForShippingType, setTabIndexForShippingType] = useState<any>(1);
    const [visibleNotFoundText, setVisibleNotFoundText] = useState(false);
    const [errorShippingNumbers, setErrorShippingNumbers] = useState('');
    const [disabledButtons, setDisabledButtons] = useState<string[]>([]);
    const operatorName = JSON.parse(localStorage.getItem('checkOperator') || '{}').username;
    const [disabledButton, setDisabledButton] = useState<any>();

    const CheckRpaStatusByShippingListNumbersRest = async () => {
        setLoading(true);
        if (shippingNumbers.trim().length === 0) {
            Swal.fire({
                icon: 'error',
                title: t('general.emptyFieldControlText'),
                showConfirmButton: false,
                timer: 1500,
            });
        } else {
            let tempArr = shippingNumbers.split('\n').map((item) => item.trim());
            ShippmentQuery.CheckRpaStatusByShippingListNumbersRest({
                shippingListNumbers: tempArr,
            })
                .then((res: any) => {
                    if (res) {
                        setVisibleNotFoundText(false);
                        let shippingRPALst = res
                            .filter((obj: any) => obj.shippingListRpaStatus === 2) //resend olanların statü 2 excelde gereksiz kolon olmamamsı için seçim yapıyoruz
                            .map((obj: any) => ({
                                orderNumber: obj.orderNumber,
                                shippingListId: obj.shippingListId,
                                shippingListNo: obj.shippingListNo,
                            }));
                        let rpaDataLst = res
                            .filter((obj: any) => obj.shippingListRpaStatus === 1) //rpa olanların stasü 1
                            .map((obj: any) => ({
                                orderNumber: obj.orderNumber,
                                shippingListId: obj.shippingListId,
                                shippingListNo: obj.shippingListNo,
                            }));
                        setReshippingdData(shippingRPALst);
                        setRpaData(rpaDataLst);
                        // eğer kayıt yoksa uyarı texti ver
                        if (shippingRPALst.length === 0 && rpaDataLst.length === 0) {
                            setVisibleNotFoundText(true);
                        }

                        if (shippingRPALst.length > 0) {
                            setTabIndexForShippingType(2);
                        } else {
                            setTabIndexForShippingType(1);
                        }
                    } //rpa yoksa varsayılan resend
                    if (tabIndexForSelectType === 1) {
                        setErrorShippingNumbers(shippingNumbers);
                        setShippingNumbers('');
                    } //tekli okumda textfield boşaltılıyor her kayıt için
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const SendShippingListNosRPAMail = async () => {
        setLoading(true);
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        }).then(async () => {
            const Arr: any = [];
            rpaData.forEach((obj: any) => {
                Arr.push(obj.shippingListNo);
            });
            ShippmentQuery.SendShippingListNosRpaMail({ shippingListNos: Arr })
                .then((res: any) => {
                    if (res) {
                        if (res.data) {
                            if (res.data.isSucceeded) {
                                Swal.fire(' ', ' ', 'success');
                            } else {
                                Swal.fire(' ', ' ', 'error');
                            }
                        }
                    }
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };
    const GetCargoLabelPdf = (shippingListId: any) => {
        setLoading(true);
        StoreQuery.GetCargoLabelPdf({ shippingListId: shippingListId })
            .then(() => {
                ShippmentQuery.UpdateShippingListStatusForReShipping({
                    shippingListId: shippingListId,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const StartRpaProcess = async (params: any) => {
        setLoading(true);
        const result = await Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        });

        if (!result.isConfirmed) {
            setLoading(false);
            return;
        }

        const shippingListNo = params.row.shippingListNo;
        try {
            const res = await RpaQuery.StartRpaProcess({ shippingListNo, userName: operatorName });
            if (res) {
                setDisabledButtons((prev) => [...prev, params.row.shippingListId]);
            }
        } catch (error: any) {
            console.log('Hata :>> ', error);
        } finally {
            setLoading(false);
        }
    };
    const StartListOfRpaProcess = () => {
        setLoading(true);
        setDisabledButton(true);
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        }).then((result) => {
            if (result.isConfirmed) {
                let req = {
                    processRPAs: rpaData.map((obj: any) => ({
                        shippingListNo: obj.shippingListNo,
                    })),
                    userName: operatorName,
                };
                RpaQuery.StartListOfRpaProcess(req)
                    .then((res: any) => {
                        if (res) {
                            if (res.data) {
                                if (res.data.isSucceeded) {
                                    Swal.fire(' ', ' ', 'success');
                                } else {
                                    Swal.fire(' ', ' ', 'error');
                                }
                            }
                        }
                    })
                    .catch((error: any) => {
                        console.log('Hata :>> ', error);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } else {
                setLoading(false);
                setDisabledButton(false);
            }
        });
    };
    return (
        <SCUIContent className={RPAR.page}>
            <div className={RPAR.breadcrumbSection}>
                <SCUIBreadCrumb title={t('rpaResender.pageTitle')} componentLink={'RPAResend'} />
            </div>
            <div className={RPAR.tabsSection}>
                <SCUITabs
                    tabList={[
                        { id: 1, name: t('rpaResender.singleSearch') },
                        { id: 2, name: t('rpaResender.multipleSearch') },
                        { id: 3, name: t('rpaResender.rpaReport') },
                    ]}
                    onChange={(_: any, activeSelectTabIndex: any) => setTabIndexForSelectType(activeSelectTabIndex)}
                    activeTabIndex={tabIndexForSelectType}
                />
            </div>
            <Grid className={RPAR.formSection} spacing={1} sx={{ paddingTop: 2 }}>
                <form
                    className={RPAR.form}
                    style={{ width: '100%' }}
                    onSubmit={(e: any) => {
                        e.preventDefault();
                        CheckRpaStatusByShippingListNumbersRest();
                    }}
                >
                    {(tabIndexForSelectType === 1 || tabIndexForSelectType == 2) && (
                        <Grid className={RPAR.formGrid} container spacing={2} sx={{ paddingTop: 2 }}>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 3,
                                    lg: 3,
                                    xl: 3,
                                }}
                            >
                                <TextField
                                    className={RPAR.shippingNumbersField}
                                    label={t('orderDetail.shippingListNo')}
                                    multiline={tabIndexForSelectType === 1 ? false : true}
                                    rows={10}
                                    onChange={(event: any) => {
                                        setShippingNumbers(event.target.value);
                                    }}
                                    value={shippingNumbers}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ marginBottom: 1, width: '100%' }}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 7,
                                    lg: 7,
                                    xl: 7,
                                }}
                            >
                                <SCUIButton
                                    className={RPAR.submitButton}
                                    text={t('general.send')}
                                    type="primary"
                                    style={{ height: '36px' }}
                                    buttonType="submit"
                                    sizeType="default"
                                    size="m"
                                />
                            </Grid>
                        </Grid>
                    )}
                </form>
                <Grid container size={{ xs: 12, md: 12, lg: 12, xl: 12 }} spacing={2}>
                    {(tabIndexForSelectType === 1 || tabIndexForSelectType == 2) && (
                        <>
                            {rpaData.length > 0 && tabIndexForShippingType === 1 && (
                                <>
                                    <Grid
                                        className={RPAR.actionsRow}
                                        size={{
                                            xs: 12,
                                            md: 6,
                                            lg: 4,
                                            xl: 4,
                                        }}
                                    >
                                        <SCUIButton
                                            className={RPAR.sendRpaButton}
                                            text={t('rpaResender.sendRpa')}
                                            type="primary"
                                            sizeType="default"
                                            size="m"
                                            onClick={() => SendShippingListNosRPAMail()}
                                        />
                                    </Grid>
                                    <SCUIButton
                                        className={RPAR.bulkRpaButton}
                                        disabled={disabledButton}
                                        text={t('rpaResender.bulkRpaSend')}
                                        type="primary"
                                        sizeType="default"
                                        size="s"
                                        onClick={() => StartListOfRpaProcess()}
                                    />
                                </>
                            )}
                            {rpaData.length > 0 || reshippingData.length > 0 ? (
                                <div style={{ width: '100%' }} className={RPAR.shippingTypeTabsWrap}>
                                    <SCUITabs
                                        tabList={[
                                            { id: 1, name: t('rpaResender.rpa') },
                                            { id: 2, name: t('rpaResender.resend') },
                                        ]}
                                        onChange={(event: any, activeShippingTypeIndex: any) =>
                                            setTabIndexForShippingType(activeShippingTypeIndex)
                                        }
                                        activeTabIndex={tabIndexForShippingType}
                                    />
                                </div>
                            ) : (
                                visibleNotFoundText && (
                                    <Grid
                                        className={RPAR.notFoundSection}
                                        sx={{ paddingLeft: 2 }}
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                        }}
                                    >
                                        <Typography
                                            className={RPAR.notFoundText}
                                            variant="caption"
                                            display="block"
                                            gutterBottom
                                            color="red"
                                        >
                                            <b>
                                                {errorShippingNumbers} {t('rpaResender.notSuitableForRpaOrResend')}
                                            </b>
                                        </Typography>
                                    </Grid>
                                )
                            )}
                            <div className={RPAR.loadingSection}>
                                <SCUILoadingLinear display={loading} />
                            </div>
                        </>
                    )}
                </Grid>

                {(tabIndexForSelectType === 1 || tabIndexForSelectType == 2) &&
                    tabIndexForShippingType === 1 &&
                    rpaData.length > 0 && (
                        <div className={RPAR.rpaGridWrap}>
                            <SCUICustomDataGrid
                                randomId
                                rows={rpaData}
                                excelDownloadButton={true}
                                excelDownloadButtonName={t('rpaResender.exportToExcel')}
                                excelDownloadData={rpaData.map(
                                    ({ shippingListId: _shippingListId, ...rest }: any) => rest
                                )}
                                excelDownloadFolderName={'rpaRecords'}
                                columns={[
                                    { field: 'shippingListNo', headerName: t('rpaResender.shipmentNo'), flex: 1 },
                                    {
                                        field: 'detay',
                                        headerName: t('general.detail'),
                                        flex: 1,
                                        align: 'center',
                                        headerAlign: 'center',
                                        renderCell: (params: any) => {
                                            const isButtonDisabled = disabledButtons.includes(
                                                params.row.shippingListId
                                            );
                                            return (
                                                <SCUIButton
                                                    className={RPAR.cellActionButtonSendRpa}
                                                    text={t('rpaResender.sendRpa')}
                                                    type="primary"
                                                    sizeType="fixed"
                                                    size={'m'}
                                                    disabled={isButtonDisabled}
                                                    onClick={() => StartRpaProcess(params)}
                                                />
                                            );
                                        },
                                    },
                                ]}
                            />
                        </div>
                    )}
                {tabIndexForShippingType === 2 && reshippingData.length > 0 && (
                    <div className={RPAR.resendGridWrap}>
                        <SCUICustomDataGrid
                            randomId
                            rows={reshippingData}
                            excelDownloadButton={true}
                            excelDownloadButtonName={t('rpaResender.exportToExcel')}
                            excelDownloadFolderName={'resendRecords'}
                            excelDownloadData={reshippingData.map(
                                ({ shippingListId: _shippingListId, ...rest }: any) => rest
                            )}
                            columns={[
                                {
                                    field: 'shippingListNo',
                                    headerName: t('general.shippingListNo'),
                                    flex: 1,
                                },
                                {
                                    field: 'detay',
                                    headerName: t('general.detail'),
                                    flex: 1,
                                    align: 'center',
                                    headerAlign: 'center',
                                    renderCell: (params: any) => {
                                        return (
                                            <SCUIButton
                                                className={RPAR.cellActionButtonDownloadLabel}
                                                text={t('rpaResender.downloadCargoLabel')}
                                                type="primary"
                                                sizeType="fixed"
                                                size={'m'}
                                                onClick={() => {
                                                    GetCargoLabelPdf(params.row.shippingListId);
                                                }}
                                            />
                                        );
                                    },
                                },
                            ]}
                        />
                    </div>
                )}
                {tabIndexForSelectType === 3 && (
                    <div className={RPAR.reportSection}>
                        <SCUIButton
                            className={RPAR.reportFullListButton}
                            text={t('rpaResender.openFullRpaList')}
                            type="secondary"
                            sizeType="default"
                            size="m"
                            onClick={() => history.push(PageUrl.RpaRequestManagement.url)}
                            style={{ marginBottom: 16, marginTop: 20 }}
                        />
                        <RpaRequestList />
                    </div>
                )}
            </Grid>
        </SCUIContent>
    );
};
